import React, { Component } from "react";
import Joi from "joi-browser";
import Form from "../common/form";
import { getDocumentsExpiryReport } from "../../services/reportService";

import BlockUi from "react-block-ui";
import { Table, Button, Message, Label } from "semantic-ui-react";
import TableTitle from "../common/tableTitle";
import auth from "../../services/authService";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ReactToPrint from "react-to-print";
import DocumentExpiryPrintReport from "./print/documentexpiry";
import queryString from "query-string";

class DocumentsExpiryReport extends Component {
  state = {
    transactions: [],
    showSalaryForm: false,
    showError: false,
    startDate: "",
    endDate: "",
    total: 0,
    search: {
      name: "",
    },
  };

  handleChangeStartDate = (date) => {
    this.setState({
      startDate: date,
    });
  };

  handleChangeEndDate = (date) => {
    this.setState({
      endDate: date,
    });
  };

  handleChange = ({ currentTarget: input }) => {
    const search = { ...this.state.search };
    search[input.name] = input.value;
    this.setState({ search });
  };

  doSubmit = async () => {
    try {
      var event = new Date(this.state.startDate);
      event.setDate(event.getDate() + 1);
      let startDate = JSON.stringify(event);
      startDate = startDate.slice(1, 11);

      event = new Date(this.state.endDate);
      event.setDate(event.getDate() + 1);
      let endDate = JSON.stringify(event);
      endDate = endDate.slice(1, 11);

      this.setState({ blocking: true });

      const verifyData = {
        startDate: startDate,
        endDate: endDate,
        name: this.state.search.name,
      };

      const { data: res } = await getDocumentsExpiryReport(verifyData);

      //this.setState({ blocking: false, transactions: res.data,total: res.total });

      // const res = await generateRoomReport(verifyData);

      if (res.proceed === "no") {
        this.setState({
          showError: true,
          //showSalaryForm: false,
          blocking: false,
        });
      } else {
        this.setState({
          showError: false,
          //showSalaryForm: true,
          blocking: false,
          transactions: res,
          total: res.total,
        });
      }
    } catch (ex) {
      if (ex.response && ex.response.status === 422) {
        const errors = { ...this.state.errors };

        if (ex.response.data.errors.name)
          errors.name = ex.response.data.errors.name;

        this.setState({ errors, blocking: false });
        //toast.warning("check validation errors.");
      }
    }
  };

  doReset = () => {
    const search = { ...this.state.search };
    search.name = "";
    this.setState({ startDate: "", endDate: "", search });
    this.reportInitialLoading();
  };

  async reportInitialLoading(verifyData) {
    this.setState({ blocking: true });
    const { data: res } = await getDocumentsExpiryReport(verifyData);
    this.setState({
      blocking: false,
      transactions: res,
      total: res.total,
      showError: false,
    });
  }

  componentDidMount() {
    const { start, end, param } = queryString.parse(this.props.location.search);

    const verifyData = {
      startDate: start,
      endDate: end,
      params: param,
    };

    this.reportInitialLoading(verifyData);
  }

  render() {
    if (auth.getCurrentUser().role != "client") {
      return "Your are authorized to perform this action.";
    }
    const { transactions } = this.state;
    return (
      <BlockUi tag="div" blocking={this.state.blocking}>
        <h1 className="container__heading">Documents Expiry</h1>

        <center>
          <div className="ui error form" style={{ width: "30%" }}>
            <Message
              negative
              style={{
                display: this.state.showError == true ? "block" : "none",
              }}
            >
              <Message.Header>Error</Message.Header>
              <p>Data not found for the dates specified.</p>
            </Message>
          </div>

          <div className="scrap-report">
            <div className="scrap-report__print">
              <ReactToPrint
                trigger={() => <a href="#">Print this out!</a>}
                content={() => this.componentRef}
              />
            </div>

            <DocumentExpiryPrintReport
              transactions={transactions}
              total={this.state.total}
              ref={(el) => (this.componentRef = el)}
            />

            <br />
          </div>
        </center>
      </BlockUi>
    );
  }
}

export default DocumentsExpiryReport;
